import { UserInfo } from 'src/app/_shared/models/userInfo';

export class FetchUserInfo {
  static readonly type = '[User] Fetch User Info';
  constructor(public userInfo: UserInfo) {}
}
